export interface AvailableVariable {
    nodeId: string;
    nodeName: any;
    nodeType: string;
    inputs: Record<string, any>;
    outputs: Record<string, any>;
}

export enum ConditionOperator {
    EQUALS = 'is equal to',
    NOT_EQUALS = 'is not equal to',
    CONTAINS = 'contains',
    NOT_CONTAINS = 'does not contain',
    STARTS_WITH = 'starts with',
    DOES_NOT_START_WITH = 'does not start with',
    ENDS_WITH = 'ends with',
    DOES_NOT_END_WITH = 'does not end with',
    MATCHES_REGEX = 'matches regex',
    DOES_NOT_MATCH_REGEX = 'does not match regex',
    IS_EMPTY = 'is empty',
    IS_NOT_EMPTY = 'is not empty',
    EXISTS = 'exists',
    DOES_NOT_EXIST = 'does not exist',
    GREATER_THAN = 'is greater than',
    LESS_THAN = 'is less than',
    GREATER_THAN_OR_EQUAL = 'is greater than or equal to',
    LESS_THAN_OR_EQUAL = 'is less than or equal to'
}
